<template>
  <div class="nav" :class="!$root.isMobile ? 'nav--large' : ''">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="nav__item"
      :class="getItemClasses(item)"
      @click.stop="item.disabled !== true ? $emit('select-item', item.id) : ''"
    >
      {{ item.title }}
      <div v-if="item.id === activeItemId && item.disabled !== true" class="item__line"></div>
    </div>
  </div>
</template>


<script lang="js">
export default {
  name: 'NavTabs',
  props: {
    items: Array,
    activeItemId: String,
  },

  methods: {
    getItemClasses(item) {
      const classes = [];
      if (item.disabled === true) classes.push('nav__item--disabled');
      else if (item.id === this.$props.activeItemId) classes.push('nav__item--active');
      return classes;
    }
  }
};
</script>


<style lang="scss" scoped>
  @import "./nav-tabs";
</style>